// extracted by mini-css-extract-plugin
module.exports = {"description":"WeekInsightText--description--1e7WH"};